export default __webpack_public_path__ + "static/Protection-bd700ecd5a82da9e4de281ef4aa897c1.png";